export default function heroPopups () {
    const openPopupButtons = document.querySelectorAll(".hero__btn-popup");
    const heroPopups = document.querySelectorAll(".hero__popup");
    const popupNextLinks = document.querySelectorAll(".popup-next");
    const popupCloseButtons = document.querySelectorAll(".hero__popup--close");
    const popupBackLinks = document.querySelectorAll(".hero__popup--back");
    const body = document.querySelector('body');

    if (openPopupButtons.length && heroPopups.length) {
        openPopupButtons.forEach((button, index) => {
            button.addEventListener("click", () => {
                heroPopups[index].classList.add("hero__popup--active");
                body.classList.add('hero-popup-active');
            });
        });

        popupNextLinks.forEach((link) => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                const popupToShow = link.getAttribute("data-popup");

                heroPopups.forEach((popup) => {
                    popup.classList.remove("popup-show");
                });

                const popupToShowElement = document.querySelector(`.hero__popup-content[data-popup="${popupToShow}"]`);
                if (popupToShowElement) {
                    popupToShowElement.classList.add("popup-show");
                }
            });
        });

        popupCloseButtons.forEach((closeButton) => {
            closeButton.addEventListener("click", closeAllPopups);
        });

        popupBackLinks.forEach((backLink) => {
            backLink.addEventListener("click", (event) => {
                event.preventDefault();
                heroPopups.forEach((popup) => {
                    popup.classList.remove("popup-show");
                });

                const popupContents = document.querySelectorAll('.hero__popup-content');
                popupContents.forEach((popupContent) => {
                    popupContent.classList.remove("popup-show");
                });
            });
        });

        function closeAllPopups () {
            heroPopups.forEach((popup) => {
                popup.classList.remove("hero__popup--active", "popup-show");
                body.classList.remove('hero-popup-active');

                const popupContents = document.querySelectorAll('.hero__popup-content');
                popupContents.forEach((popupContent) => {
                    popupContent.classList.remove("popup-show");
                });
            });
        }

        document.addEventListener("click", (event) => {
            const isClickInsidePopupContent = Array.from(heroPopups).some((popup) => {
                const popupContents = popup.querySelectorAll(".hero__popup-content, .hero__popup-content--additional");
                return Array.from(popupContents).some((popupContent) => popupContent.contains(event.target));
            });

            if (!isClickInsidePopupContent && !event.target.matches(".hero__btn-popup") && !event.target.matches(".hero__popup--back")) {
                closeAllPopups();
            }
        });

        const popupContents = document.querySelectorAll('.hero__popup-content');
        let maxHeight = 0;

        function setMaxHeight () {
            if (window.innerWidth > 1023) {
                popupContents.forEach((popupContent) => {
                    const height = popupContent.clientHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });

                const heroPopupList = document.querySelector('.hero__popup-list');
                if (heroPopupList) {
                    heroPopupList.style.height = `${maxHeight}px`;
                }
            } else {
                const heroPopupList = document.querySelector('.hero__popup-list');
                if (heroPopupList) {
                    heroPopupList.style.height = '';
                }
            }
        }

        setMaxHeight();

        window.addEventListener('resize', () => {
            setMaxHeight();
        });
    }
}
